import React, { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';

export default function ReputationBadge({ userId, className = '' }) {
  const [score, setScore] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const res = await apiFetch(`/api/reputation/${userId}`);
        if (!res.ok) throw new Error();
        const data = await res.json();
        if (on) setScore(data?.score ?? 0);
      } catch {
        if (on) setScore(null);
      } finally {
        if (on) setLoading(false);
      }
    })();
    return () => { on = false; };
  }, [userId]);

  if (loading) return <span className={className}>Reputation: …</span>;
  if (score == null) return <span className={className}>Reputation: N/A</span>;
  return <span className={className} title="On-time payments & confirmations">Reputation: {score}</span>;
}
